import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const INVENTORYADJUSTMENTREASON_API = "/inventoryAdjustmentReasons";

// ----------------------- STATE ------------------------- //
const state = {
  inventoryadjustmentreason_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getInventoryAdjustmentReason: state =>
    getField(state.inventoryadjustmentreason_data[state.currentIndex]),

  getCurrentInventoryAdjustmentReason: state => {
    return state.inventoryadjustmentreason_data[state.currentIndex];
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateInventoryAdjustmentReason(state, payload) {
    updateField(
      state.inventoryadjustmentreason_data[state.currentIndex],
      payload
    );
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.inventoryadjustmentreason_data.findIndex(
      inventoryadjustmentreason => inventoryadjustmentreason.id == theID
    );
  },

  loadAllInventoryAdjustmentReasons(state, payload) {
    state.inventoryadjustmentreason_data = payload.data;
    state.currentIndex = 0;
  },

  addInventoryAdjustmentReason(state, payload) {
    state.inventoryadjustmentreason_data.push(payload.data);
    state.currentIndex = state.inventoryadjustmentreason_data.length - 1;
  },

  saveInventoryAdjustmentReason(state, payload) {
    state.inventoryadjustmentreason_data[state.currentIndex] = payload.data;
  },

  fetchInventoryAdjustmentReason(state, payload) {
    if (state.currentIndex == -1) {
      state.inventoryadjustmentreason_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.inventoryadjustmentreason_data[state.currentIndex] = payload.data;
    }
  },

  deleteInventoryAdjustmentReason(state, payload) {
    state.currentIndex = state.inventoryadjustmentreason_data.findIndex(
      inventoryadjustmentreason =>
        inventoryadjustmentreason.id == payload.data.id
    );
    state.inventoryadjustmentreason_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.inventoryadjustmentreason_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllInventoryAdjustmentReasons({ commit }) {
    try {
      commit(
        "loadAllInventoryAdjustmentReasons",
        await Repository.get(`${INVENTORYADJUSTMENTREASON_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addInventoryAdjustmentReason({ commit }) {
    await Repository.get(`${INVENTORYADJUSTMENTREASON_API}/new`)
      .then(response => {
        commit("addInventoryAdjustmentReason", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveInventoryAdjustmentReason({ state, commit }) {
    try {
      commit(
        "saveInventoryAdjustmentReason",
        await Repository.post(
          `${INVENTORYADJUSTMENTREASON_API}`,
          state.inventoryadjustmentreason_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchInventoryAdjustmentReason({ commit }, payloadID) {
    try {
      commit(
        "fetchInventoryAdjustmentReason",
        await Repository.get(`${INVENTORYADJUSTMENTREASON_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteInventoryAdjustmentReason({ commit }, payloadID) {
    try {
      commit(
        "deleteInventoryAdjustmentReason",
        await Repository.delete(`${INVENTORYADJUSTMENTREASON_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchInventoryAdjustmentReasons({ commit }, searchTerm) {
    try {
      commit(
        "loadAllInventoryAdjustmentReasons",
        await Repository.get(
          `${INVENTORYADJUSTMENTREASON_API}/search?q=${searchTerm}`
        )
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
